import styled from 'styled-components';

export const StldCardTableAtividadesOptions = styled.article`
border: solid #E8E8E8 1px;
border-radius: .25rem;
padding: 0.3rem;
margin: 0.2rem;
background-color: #fff;
height: fit-content;
text-align: center;

& .info-sections {
    width: 100%;
    font-si
}

& .menu-sections {
    width: 10%;
}

& .content-warning {
    background-color: #fff3cd;
    border: solid #fff3cd 1px !important;
}

.title-card {
    font-weight: 1000;
    font-size: 12px;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 40ch;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;


    @supports (-webkit-line-clamp: 3) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
}

.flex-title-text-right {
    text-align: right;
    width: 50%;
}

.title-card-legend {
    color: gray;
    font-size: 11px;
}

.data-info {
    color: gray;
    font-weight: 1000;
    font-size: 14px;
}

.card-align {
    text-align: center;
    height : 300px;
}

.legend-time {
    font-size: 14px;
    color: #2c3b82;
    font-weight: 1000;
}

.time {
    font-size: 15px;
    color: #2c3b82;
    font-weight: 1000;
}

.legend-activity {
    font-size: 14px;
    margin: 0.5rem;
    width: 100%;
    text-align: left;
}

.legend-description {
    font-size: 0.8rem;
    margin: 0.5rem;
    width: 100%;
    text-align: left;
    font-weight: 1000;
}

.legend-title-text {
    font-size: 0.6rem;
    font-weight: 1000;
    text-align: left;
}

.legend-value {
    font-size: 0.8rem;
    color: green;
    font-weight: 1000;
}

.legend-value-sub-value {
    font-size: 0.8rem;
    color: #2c3b82;
    font-weight: 1000;
}

.legend-value-nowrap{
    white-space: nowrap;
}


.name-info {
    color: #2c3b82;
    font-weight: 1000;
    font-size: 14px;
    background: #E8E8E8;
    border-radius: 10px;
}

.flex-column-1 {
    width: 50%;
}

.flex-column-2 {
    width: 50%;
}

.flex-column-title {
    width: 100%;
    text-align: left;
}

.flex-column-title-icon {
    text-align: right;
}

.button-icon {
    background: transparent;
    border: none;
}

.menu-popup {
    width: 50%;
    background: black;
    color: white;
    z-index: 9;
}

.flex-column-left {
    margin-left: 0.5rem;
    width: 60%;
    text-align: left;
}

.footer-details {
    color: #2c3b82;
    font-size: 11px;
}

.details {
    color: #2c3b82;
    font-size: 12px;
    font-weight: 1000;
}

.flex-title-left {
    margin-left: 0.5rem;
    text-align: left;
    width: 100%;
}

.flex-column-right {
    margin-right: 0.5rem;
    width: 50%;
    text-align: right;
}

.flex-column-center {
    margin-right: 0.5rem;
    width: 100%;
    text-align: center;
}

.flex-title-text-left {
    margin-right: 0.5rem;
    text-align: left;
    width: 50%;
}

.flex-title-icon-center {
    text-align: center;
    margin-top: 0.5rem;
    width: 10%;
}

.flex-column-title-right {
    margin-right: 0.5rem;
    width: 10%;
    text-align: right;
}

.footer-details {
    color: #2c3b82;
    font-size: 11px;
}

.flex-column-footer-1 {
    margin-left: 0.5rem;
    width: 30%;
    text-align: left;
}

.flex-column-footer-2 {
    margin-left: 0.5rem;
    width: 70%;
    text-align: left;
}

.card-menu-hide {
    background: black;
    color: #fff;
    margin: 1rem;
    font-size: 11px;
    display: none;
    width: 50%;
    padding: 5px;
    border-radius: 7px;
}

.card-menu-show {
    background: black;
    color: blue;
    margin-top: 1.5rem;
    font-size: 11px;
    display: block;
    position: absolute;
    padding: 0px;
    list-style-type: none;
    background-color: white;
    border-radius: 12px;
    border: 1px solid #E8E8E8;
    box-shadow: 0px 0px 24px rgba(0,0,0,0.05);
    font-size: 13px;
}

.card-menu-title {
    width: 75%;
    text-align: right;
}

.card-menu-title-right {
    width: 25%;
    text-align: right;
}

.card-menu-title-left {
    width: 25%;
    text-align: left;
}

.menu-card {
    padding: 0.5rem 2rem;
    border-bottom: 0px solid #fff;
    color: #000;
    &:hover {
        color: #2c3b82;
        font-weight: bold;
        cursor: pointer;
    }
}

.menu-link {
    color: transparent ;
}

.text-max-40-mobile{
    white-space: nowrap;
    max-width: 40ch;
    overflow: hidden;
    text-overflow: ellipsis;
}




@media only screen and (max-width: 412px) {
    .text-max-40-mobile{
        white-space: nowrap;
        max-width: 40ch;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

@media only screen and (max-width: 512px) {
    .text-max-40-mobile{
        white-space: nowrap;
        max-width: 40ch;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

&.table-data-info-warning {
    background-color: #fff3cd;
}

&.table-data-info-canceled {
    background-color: #FF7F7F;
}

&.table-data-info-pro-bono {
    background: #cdeeff;
}

`